import GenericRequest, { METHOD_POST } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';
import RouterUtils from '../../shared/routing/RouterUtils';

export default class UpdateUserRequest extends GenericRequest {

    user;

    constructor(userId, user) {
        super(METHOD_POST, RouterUtils.generateRoute(ApiEndpoints.USER_ID, { id: userId }));
        this.user = user;
    }

    overrideRequest() {
        let request = {};
        if ( this.user ) request = { ...request, ...this.user };
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/users/ws/UpdateUserRequest.js